import { NavLink } from 'react-router-dom';
import { MdBarChart, MdTrendingUp } from 'react-icons/md';

const AnalyticsNavTabs = () => {
  return (
    <div className="flex items-center gap-1.5 p-1 bg-slate-100 rounded-xl w-fit border border-slate-200 mb-6 shadow-2xs">
      <NavLink
        to="/analytics"
        end
        className={({ isActive }) =>
          `flex items-center gap-2 px-4 py-2 rounded-lg text-xs md:text-sm font-semibold transition-all duration-150 ${
            isActive
              ? 'bg-white text-slate-900 shadow-xs border border-slate-200/80'
              : 'text-slate-600 hover:text-slate-900 hover:bg-white/60'
          }`
        }
      >
        <MdBarChart className="text-base text-primary" />
        <span>Platform Overview</span>
      </NavLink>

      <NavLink
        to="/ai-analytics"
        className={({ isActive }) =>
          `flex items-center gap-2 px-4 py-2 rounded-lg text-xs md:text-sm font-semibold transition-all duration-150 ${
            isActive
              ? 'bg-white text-slate-900 shadow-xs border border-slate-200/80'
              : 'text-slate-600 hover:text-slate-900 hover:bg-white/60'
          }`
        }
      >
        <MdTrendingUp className="text-base text-indigo-600" />
        <span>AI Cost & Telemetry</span>
      </NavLink>
    </div>
  );
};

export default AnalyticsNavTabs;
